import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-scroll';
import { motion, AnimatePresence } from 'framer-motion';
import ShinyText from './SninyText';

const NavBar = () => {
    const [nav, setNav] = useState(false);

    const links = [
        { id: 1, link: 'Home' },
        { id: 2, link: 'About' },
        { id: 3, link: 'Portfolio' },
        { id: 4, link: 'Skills' },
        { id: 5, link: 'Contact' },
    ];

    return (
        <div className={`select-none z-50 bg-black/30 backdrop-blur-xl flex justify-between items-center w-full text-white fixed px-4 flex-col border-b border-slate-600`}>
            <div className='flex py-4 justify-between w-full items-center'>
                <h1 className='text-5xl font-signature ml-2 cursor-pointer '>
                <ShinyText text="Utkarsh" disabled={false} speed={5} className='custom-class' />
                </h1>

                {/* Desktop Navigation */}
                <ul className="hidden md:flex">
                    {links.map(({ id, link }) => (
                        <li key={id} className='px-4 cursor-pointer capitalize font-medium text-gray-500 hover:text-gray-100 hover:scale-125 duration-200'>
                            <Link to={link} smooth duration={500}>
                                {link}
                            </Link>
                        </li>
                    ))}
                </ul>

                {/* Mobile Menu Icon */}
                <div onClick={() => setNav(!nav)} className='cursor-pointer md:hidden pr-4 z-10 text-gray-500 duration-200 hover:scale-105 hover:text-gray-200'>
                    {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
                </div>
            </div>

            {/* Mobile Navigation Menu with Smooth Height Animation */}
            <AnimatePresence>
                {nav && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                        className='overflow-hidden w-full'
                    >
                        <ul className='flex flex-col w-full text-gray-300 text-xl px-5 py-3'>
                            {links.map(({ id, link }, i) => (
                                <motion.p
                                    initial={{ opacity: 0, x: -30 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.4, delay: 0.1 + 0.06 * i }}
                                    key={id}
                                    className='py-1'
                                >
                                    <Link
                                        onClick={() => setNav(false)}
                                        to={link}
                                        smooth
                                        duration={500}
                                    >
                                        {link}
                                    </Link>
                                </motion.p>
                            ))}
                        </ul>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default NavBar;
